import { ADD_NICK_NAME } from '../../../actions/action-types';
import { API_CALL } from '../../../middleware/api';
import {
  GET_FILTER_DATA,
  SHIPPER_CAPS_DETAILS,
  SHIPPER_CAPS_DETAILS_CLEAR,
  SHIPPER_CAPS_SCHEDULE_DETAILS,
  SHIPPER_CAPS_PLOT_DATA,
  UPDATE_DEVICE_SAMPLE,
} from './constants';

export const actions = {
  getFillterData: deviceId => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/v1/caps/${deviceId}/event-types`,
    },
    type: GET_FILTER_DATA,
  }),
  getCapsDetails: (id, pageRequest) => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/esi/v1/caps/' + id,
      params: pageRequest,
    },
    type: SHIPPER_CAPS_DETAILS,
  }),

  addNickName: data => ({
    [API_CALL]: {
      endpoint: `portal/esi/v1/caps`,
      method: 'put',
      data,
    },
    type: ADD_NICK_NAME,
  }),

  updateDeviceSample: (deviceId, isSample) => ({
    [API_CALL]: {
      endpoint: `portal/v1/devices/${deviceId}/sample`,
      method: 'PUT',
      data: { is_sample: isSample },
    },
    type: UPDATE_DEVICE_SAMPLE,
  }),

  clearCapsDetails: () => ({
    type: SHIPPER_CAPS_DETAILS_CLEAR,
  }),

  getPlotScheduleDetail: (id, params) => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/devices/v1/cap/' + id + '/schedule_details',
      params,
    },
    type: SHIPPER_CAPS_SCHEDULE_DETAILS,
  }),

  getPlotData: (id, params) => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/devices/v1/cap/${id}/plot`,
      params,
    },
    type: SHIPPER_CAPS_PLOT_DATA,
  }),
};
